package com.havn.app.core.platform

import androidx.compose.runtime.Composable

@Composable
actual fun HavnKioskSystemBars(active: Boolean) = Unit
